// Base classes for all badges
export const baseClasses = "inline-flex items-center font-medium";

// Variant-specific color classes
export const variantClasses: Record<BadgeVariant, string> = {
  // Role badges
  admin:
    "bg-blueLight-50 text-blueLight-700  border border-blueLight-200 rounded-full",
  procurement:
    "bg-utilityOrange-50 text-utilityOrange-700  border border-utilityOrange-200 rounded-full",
  clinical:
    "bg-utilityIndigo-50 text-utilityIndigo-700  border border-utilityIndigo-200 rounded-full",

  // Facility badges
  HOSPITAL: "bg-pink-50 text-pink-700  border border-pink-200 rounded-full",
  POLY_CLINIC:
    "bg-purple-50 text-purple-700  border border-purple-200 rounded-full",
  OTHER:
    "bg-blueLight-50 text-blueLight-700  border border-blueLight-200 rounded-full",

  // Status badges
  active:
    "bg-success-50 text-success-700  border border-success-200 rounded-sm ",
  pending:
    "bg-warning-50 text-warning-700  border border-warning-200 rounded-sm",
  offline: "bg-gray-50 text-gray-600  border border-gray-300 rounded-sm",

  // Percentage indicator
  percentage: "bg-error-50 text-error-700 border border-error-200 rounded-full",

  // Catalog badges
  VARIATION: "bg-purple-50 text-purple-700  border border-purple-200 rounded-sm",
  PUBLISHED: "bg-success-50 text-success-700  border border-success-200 rounded-full  ",

  //category badges
  firstCategory: "bg-utilityBrand-50 text-utilityBrand-700  border border-utilityBrand-200 rounded-full ",
  secondCategory: "bg-utilityBlue-50 text-utilityBlue-700  border border-utilityBlue-200 rounded-full ",
  thirdCategory: "bg-utilityIndigo-50 text-utilityIndigo-700  border border-utilityIndigo-200 rounded-full ",

  // Default
  default:
    "bg-utilityGray-50 text-utilityGray-700 border border-utilityGray-200 rounded-full",
};

// Size classes
export const sizeClasses = {
  sm: "text-xs px-2 py-0.5",
  md: "text-xs px-2.5 py-0.5",
  lg: "text-sm px-3 py-1",
};

export const roundedClasses = {
  full: "rounded-full",
  sm: "rounded-sm",
  md: "rounded-md",
  lg: "rounded-lg",
};
export type BadgeVariant =
  // Role badges
  | "admin"
  | "procurement"
  | "clinical"
  // Facility badges
  | "HOSPITAL"
  | "POLY_CLINIC"
  | "OTHER"
  // Status badges
  | "active"
  | "pending"
  | "offline"
  // Percentage indicator
  | "percentage"
  // Catalog badges
  | "VARIATION"
  | "PUBLISHED"
  //category badges
  | "firstCategory"
  | "secondCategory"
  | "thirdCategory"
  // Default
  | "default";
